import * as React from "react";

export default function SortDescendingIcon({ fill, ...props }: React.SVGProps<any>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 38 24" {...props}>
      <path
        d="M19.07 24a5.02 5.02 0 0 1-3.553-1.47L1.444 8.489C.02 7.075-.393 4.941.394 3.055 1.18 1.17 2.918 0 4.931 0h28.138c2.013 0 3.75 1.171 4.537 3.055.787 1.886.374 4.02-1.052 5.436L22.489 22.597A4.819 4.819 0 0 1 19.071 24zM4.93 2.97c-1.171 0-1.653.935-1.772 1.22-.257.616-.286 1.517.404 2.202l14.073 14.041c.736.73 2.023.776 2.733.069L34.433 6.396c.695-.69.667-1.59.41-2.205-.12-.286-.602-1.221-1.774-1.221H4.931z"
        fill={fill || "#627D98"}
        fillRule="nonzero"
      />
    </svg>
  );
}
